import React, { FC, memo } from 'react';
import { Typography } from '@packages/ui/shared';
import { TableHeader, TableRow } from '@web/components/table';
import { useTranslation } from 'react-i18next';

const TABLE_HEADERS = [
    { key: 'report', label: 'cidCvnCheck:table.headerLabels.report' },
    { key: 'checkResult', label: 'cidCvnCheck:table.headerLabels.checkResult' },
    { key: 'createdBy', label: 'cidCvnCheck:table.headerLabels.createdBy' },
    { key: 'createdDate', label: 'cidCvnCheck:table.headerLabels.createdDate' },
    { key: 'actions', label: 'cidCvnCheck:table.headerLabels.actions' },
];

export const CidCvnTableHeaders: FC = memo(() => {
    const { t } = useTranslation();

    return (
        <TableRow>
            {TABLE_HEADERS.map(({ key, label }) => (
                <TableHeader key={key}>
                    <Typography variant="label">{t(label)}</Typography>
                </TableHeader>
            ))}
        </TableRow>
    );
});
